import React from "react";
import Skeleton from "../ui/Skeleton";

export const AdminPanelSkeleton: React.FC = () => {
  return (
    <div className="w-full flex flex-col gap-2 animate-pulse">
      {/* Navbar segmentada (mesma geometria do controle real) */}
      <div className="w-full flex gap-1 bg-gray-100 p-1 rounded-lg">
        {[1, 2, 3].map((i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            width="100%"
            height={30}
            className="rounded-lg flex-1 opacity-40"
          />
        ))}
      </div>

      {/* KPIs */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="relative bg-white rounded-xl border border-purple-100 p-4 shadow-xs flex flex-col gap-3 overflow-hidden"
          >
            <div className="absolute top-0 left-0 right-0 h-[3px] bg-purple-100" />
            <div className="flex items-start justify-between pt-0.5">
              <div className="space-y-1.5">
                <Skeleton variant="text" width={70} height={8} />
                <Skeleton variant="text" width={40} height={22} />
              </div>
              <Skeleton
                variant="rectangular"
                width={36}
                height={36}
                className="rounded-lg shrink-0"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminPanelSkeleton;
